import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { GridList, GridListTile } from '@material-ui/core';
import Lightbox from 'react-images';

const styles = () => ({
  gridList: {
    margin: 0,
    padding: 0,
  },
  photo: {
    cursor: 'pointer'
  }
});

class Photos extends React.Component {
  constructor() {
    super();

    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox(index) {
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  }
  
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {
    const { classes, photos } = this.props;
    const urls = photos.map(photo => ({ src: photo.url }));

    return (
      <div className="row gallery">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>Zdjęcia</h2>
            </div>
          </div>
        </div>
        <div className="box gallery-content">
          <GridList cellHeight={160} className={classes.gridList} cols={4}>
            {photos.map((photo, index) => (
              <GridListTile key={index}>
                  <a onClick={() => this.openLightbox(index)} style={{margin: 15}}>
                    <img 
                      src={photo.url} 
                      alt={photo.description || photo.fileName} 
                      className={classes.photo}
                      title="Powiększ"
                      style={{height: 130, objectFit: 'cover'}}
                    />
                  </a>
              </GridListTile>
            ))}
          </GridList>
          <Lightbox images={urls}
            onClose={this.closeLightbox}
            onClickPrev={this.gotoPrevious}
            onClickNext={this.gotoNext}
            currentImage={this.state.currentImage}
            isOpen={this.state.lightboxIsOpen}
            closeButtonTitle="Zamknij (Esc)"
            imageCountSeparator=" z "
            leftArrowTitle="Poprzednie"
            rightArrowTitle="Następne"
            backdropClosesModal={true}
          />
        </div>
      </div>
    );
  }
}

Photos.propTypes = {
  classes: PropTypes.object.isRequired,
  photos: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(Photos);


// WEBPACK FOOTER //
// ./src/components/consultationSurveys/Photos.js